import { useState } from 'react';
import { 
  Button, TextField, Grid, Typography, Modal,
  Box
} from '@mui/material';
import PropTypes from 'prop-types';

import { changePass } from '../../actions/users';
import { isEmpty } from '../common/helpers';

const CrearPassModal = ({
  show, handleClose, setModalStatus, setModalPass
}) => {
  const [data, setData] = useState({
    password: '',
    password2: ''
  });
  const [error, setError] = useState({
    password: '',
    password2: ''
  });

  const cambiarPass = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  }

  const guardar = async e => {
    e.preventDefault();
    if(isEmpty(data.password)){
      return setError({
        password: 'Un campo esta vacio',
        password2: 'Un campo esta vacio'
      })
    }
    if(data.password !== data.password2){
      return setError({
        password: 'No coinciden',
        password2: 'No coinciden'
      });
    }
    if(data.password.length < 7){
      return setError({
        password: 'Debe de tener más de 6',
        password2: 'Debe de tener más de 6'
      });
    }
    const info = {
      password: data.password
    }
    const resChange = await changePass(info);
    if(resChange){
      setModalPass(false);
      setModalStatus({ 
        show: true, 
        type: "SUCCESS", 
        message: "La contraseña fue cambiada satisfactoriamente"
      });
    } else {
      setModalStatus({
        show: true,
        type: "ERROR",
        message: "Problema al guardarlo."
      });
    }
  }

  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={show}
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "70%",
          maxWidth: "sm",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 5,
        }}
      >
        <Typography color="primary" mb={3} mt={3} variant="h4" component="h5">
          Cambiar contraseña
        </Typography>
        <form noValidate onSubmit={guardar}>
          <Grid container sx={{my:2}} spacing={{ sx: 1}}>
            <Grid item size={{xs: 12}}>
              <TextField
                error={isEmpty(error.password) ? false : true}
                type="password"
                variant="outlined"
                fullWidth
                id="password"
                label="Contraseña"
                name="password"
                value={data.password}
                onChange={cambiarPass}
                helperText={!isEmpty(error.password) && error.password}
              />
            </Grid>
            <Grid className="content-description" item size={{xs: 12, md: 6}}>
              <Typography color="#737791" variant="body2" sx={{marginTop: 2}}>
                Tu contraseña debe:
              </Typography>
              <ul className="list">
                <li>
                  <Typography color="#737791" variant="body2">Mínimo 8 caracteres.</Typography>
                </li>
                <li>
                  <Typography color="#737791" variant="body2">Mínimo 2 números.</Typography>
                </li>
                <li>
                  <Typography color="#737791" variant="body2">Mínimo 1 carácter especial.</Typography>
                </li>
                <li>
                  <Typography color="#737791" variant="body2">Mínimo 1 letra mayúscula.</Typography>
                </li>
                <li>
                  <Typography color="#737791" variant="body2">Mínimo 1 letra minúscula.</Typography>
                </li>
              </ul>
            </Grid>
            <Grid item size={{xs: 12}}>
              <TextField
                error={isEmpty(error.password2) ? false : true}
                type="password"
                variant="outlined"
                fullWidth
                id="password2"
                label="Confirmar password"
                name="password2"
                value={data.password2}
                onChange={cambiarPass}
                helperText={!isEmpty(error.password2) && error.password2}
              />
            </Grid>
          </Grid>
          <Grid item size={12} sx={{mt: 3}}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
            >
              Guardar
            </Button>
            <Button
              variant="contained"
              color="default"
              onClick={handleClose}
              fullWidth
              sx={{mt: 2}}
            >
              Cancelar
            </Button>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
}

CrearPassModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setModalStatus: PropTypes.func.isRequired,
  setModalPass: PropTypes.func.isRequired,
}

export default CrearPassModal;